import Page from 'attendee/theme/Page'
import React from 'react'
import styled from 'styled-components'
import AssistantIcon from '@mui/icons-material/Assistant'
import SettingsRemoteIcon from '@mui/icons-material/SettingsRemote'
import InterpreterModeIcon from '@mui/icons-material/InterpreterMode'
import WebIcon from '@mui/icons-material/Web'
import PointOfSaleIcon from '@mui/icons-material/PointOfSale'
import SmsIcon from '@mui/icons-material/Sms'
import AccountBalanceIcon from '@mui/icons-material/AccountBalance'
import TrendingDownIcon from '@mui/icons-material/TrendingDown'
import {HelpButton, HelpButtonHolder, HelpText} from 'attendee'
import {routes} from 'routes/routes'
import CorporateFareIcon from '@mui/icons-material/CorporateFare'
import CounterShape from 'assets/img/shape/counter-shape.png'
import {WhyOnlineEvent} from 'attendee/theme/WhyOnlineEvent'
import hometalker from 'assets/custom_images/hometalker.png'
import {Helmet} from 'react-helmet'
import {DEFAULT_OG_IMAGE, SITE_ORIGIN} from 'seo/siteMeta'
import AttachMoneyIcon from '@mui/icons-material/AttachMoney'
import VerifiedIcon from '@mui/icons-material/Verified'
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive'
import SecurityIcon from '@mui/icons-material/Security'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import {useI18n} from 'i18n/I18nContext'
import {withLocalePath} from 'i18n/localePaths'

export function Info() {
  const {locale, t} = useI18n()
  const pageUrl = `${SITE_ORIGIN}${withLocalePath(locale, routes.info)}`

  return (
    <Page>
      <>
        <Helmet>
          <title>{t('info.metaTitle')}</title>
          <meta name="description" content={t('info.metaDescription')} />
          <link rel="canonical" href={pageUrl} />
          <meta property="og:title" content={t('info.ogTitle')} />
          <meta property="og:description" content={t('info.ogDescription')} />
          <meta property="og:url" content={pageUrl} />
          <meta property="og:image" content={DEFAULT_OG_IMAGE} />
          <meta property="og:image:secure_url" content={DEFAULT_OG_IMAGE} />
          <meta property="og:image:type" content="image/jpeg" />
          <meta property="og:image:width" content="1200" />
          <meta property="og:image:height" content="630" />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content={t('info.ogTitle')} />
          <meta
            name="twitter:description"
            content={t('info.ogDescription')}
          />
          <meta name="twitter:image" content={DEFAULT_OG_IMAGE} />
        </Helmet>

        <section className="contact_section dark_light_class pt-55 pb-55">
          <div className="container">
            <div className="section__title-wrapper mb-80">
              <span className="section__back-title">{t('info.heroBack')}</span>
              <span className="section__subtitle">
                {t('info.heroSubtitle')}
              </span>
              <h1 className="section__title">
                {t('info.heroTitleBefore')}{' '}
                <span className="text__highlight">
                  {t('info.heroTitleHighlight')}
                </span>
              </h1>
            </div>

            <StyledBlockquote
              cite="/blog"
              style={{backgroundImage: `url(${hometalker})`}}
            >
              <h3 className="blockquote_content mb-0">{t('info.lead')}</h3>
            </StyledBlockquote>

            <div className="row ">
              <InfoItem className="col-xxl-4 col-xl-4 col-lg-6">
                <div>
                  <InfoItemHeader>{t('info.feature1Title')}</InfoItemHeader>
                  <InfoItemContent>
                    <InfoItemIcon>
                      <AssistantIcon />
                    </InfoItemIcon>
                    {t('info.feature1Body')}
                  </InfoItemContent>
                </div>
              </InfoItem>

              <InfoItem className="col-xxl-4 col-xl-4 col-lg-6">
                <div>
                  <InfoItemHeader>{t('info.feature2Title')}</InfoItemHeader>
                  <InfoItemContent>
                    <InfoItemIcon>
                      <SettingsRemoteIcon />
                    </InfoItemIcon>
                    {t('info.feature2Body')}
                  </InfoItemContent>
                </div>
              </InfoItem>

              <InfoItem className="col-xxl-4 col-xl-4 col-lg-6">
                <div>
                  <InfoItemHeader>{t('info.feature3Title')}</InfoItemHeader>
                  <InfoItemContent>
                    <InfoItemIcon>
                      <InterpreterModeIcon />
                    </InfoItemIcon>
                    {t('info.feature3Body')}
                  </InfoItemContent>
                </div>
              </InfoItem>

              <InfoItem className="col-xxl-4 col-xl-4 col-lg-6">
                <div>
                  <InfoItemHeader>{t('info.feature4Title')}</InfoItemHeader>
                  <InfoItemContent>
                    <InfoItemIcon>
                      <WebIcon />
                    </InfoItemIcon>
                    {t('info.feature4Body')}
                  </InfoItemContent>
                </div>
              </InfoItem>

              <InfoItem className="col-xxl-4 col-xl-4 col-lg-6">
                <div>
                  <InfoItemHeader>{t('info.feature5Title')}</InfoItemHeader>
                  <InfoItemContent>
                    <InfoItemIcon>
                      <PointOfSaleIcon />
                    </InfoItemIcon>
                    {t('info.feature5Body')}
                  </InfoItemContent>
                </div>
              </InfoItem>

              <InfoItem className="col-xxl-4 col-xl-4 col-lg-6">
                <div>
                  <InfoItemHeader>{t('info.feature6Title')}</InfoItemHeader>
                  <InfoItemContent>
                    <InfoItemIcon>
                      <SmsIcon />
                    </InfoItemIcon>
                    {t('info.feature6Body')}
                  </InfoItemContent>
                </div>
              </InfoItem>

              <InfoItem className="col-xxl-4 col-xl-4 col-lg-6">
                <div>
                  <InfoItemHeader>{t('info.feature7Title')}</InfoItemHeader>
                  <InfoItemContent>
                    <InfoItemIcon>
                      <AccountBalanceIcon />
                    </InfoItemIcon>
                    {t('info.feature7Body')}
                  </InfoItemContent>
                </div>
              </InfoItem>

              <InfoItem className="col-xxl-4 col-xl-4 col-lg-6">
                <div>
                  <InfoItemHeader>{t('info.feature8Title')}</InfoItemHeader>
                  <InfoItemContent>
                    <InfoItemIcon>
                      <TrendingDownIcon />
                    </InfoItemIcon>
                    {t('info.feature8Body')}
                  </InfoItemContent>
                </div>
              </InfoItem>

              <InfoItem className="col-xxl-4 col-xl-4 col-lg-6">
                <div>
                  <InfoItemHeader>{t('info.feature9Title')}</InfoItemHeader>
                  <InfoItemContent>
                    <InfoItemIcon>
                      <NotificationsActiveIcon />
                    </InfoItemIcon>
                    {t('info.feature9Body')}
                  </InfoItemContent>
                </div>
              </InfoItem>

              <InfoItem className="col-xxl-4 col-xl-4 col-lg-6">
                <div>
                  <InfoItemHeader>{t('info.feature10Title')}</InfoItemHeader>
                  <InfoItemContent>
                    <InfoItemIcon>
                      <VerifiedIcon />
                    </InfoItemIcon>
                    {t('info.feature10Body')}
                  </InfoItemContent>
                </div>
              </InfoItem>

              <InfoItem className="col-xxl-4 col-xl-4 col-lg-6">
                <div>
                  <InfoItemHeader>{t('info.feature11Title')}</InfoItemHeader>
                  <InfoItemContent>
                    <InfoItemIcon>
                      <AttachMoneyIcon />
                    </InfoItemIcon>
                    {t('info.feature11Body')}
                  </InfoItemContent>
                </div>
              </InfoItem>

              <InfoItem className="col-xxl-4 col-xl-4 col-lg-6">
                <div>
                  <InfoItemHeader>{t('info.feature12Title')}</InfoItemHeader>
                  <InfoItemContent>
                    <InfoItemIcon>
                      <SecurityIcon />
                    </InfoItemIcon>
                    {t('info.feature12Body')}
                  </InfoItemContent>
                </div>
              </InfoItem>
            </div>

            <div className="section__title-wrapper mt-100 mb-40">
              <span className="section__back-title">
                {t('info.platformBack')}
              </span>
              <span className="section__subtitle">
                {t('info.platformSubtitle')}
              </span>
              <h2 className="section__title">
                {t('info.platformTitleBefore')}{' '}
                <span className="text__highlight">
                  {t('info.platformTitleHighlight')}
                </span>
              </h2>
            </div>

            <ProblemContainer className="mb-60">
              <ProblemGrid>
                <ProblemColumn>
                  <ProblemHeader>{t('info.problemUsualHeader')}</ProblemHeader>
                  <ProblemList>
                    <li>{t('info.problemUsual1')}</li>
                    <li>{t('info.problemUsual2')}</li>
                    <li>{t('info.problemUsual3')}</li>
                    <li>{t('info.problemUsual4')}</li>
                    <li>{t('info.problemUsual5')}</li>
                    <li>{t('info.problemUsual6')}</li>
                  </ProblemList>
                </ProblemColumn>

                <ProblemColumn>
                  <ProblemHeader>{t('info.problemEventaHeader')}</ProblemHeader>
                  <SolutionList>
                    <li>{t('info.problemEventa1')}</li>
                    <li>{t('info.problemEventa2')}</li>
                    <li>{t('info.problemEventa3')}</li>
                    <li>{t('info.problemEventa4')}</li>
                    <li>{t('info.problemEventa5')}</li>
                    <li>{t('info.problemEventa6')}</li>
                  </SolutionList>
                </ProblemColumn>
              </ProblemGrid>
            </ProblemContainer>

            <div className="section__title-wrapper mt-60 mb-40">
              <span className="section__back-title">{t('info.joinBack')}</span>
              <span className="section__subtitle">
                {t('info.joinSubtitle')}
              </span>
              <h2 className="section__title">
                {t('info.joinTitleBefore')}{' '}
                <span className="text__highlight">
                  {t('info.joinTitleHighlight')}
                </span>
              </h2>
            </div>

            <StepsFlow>
              <StepCard>
                <StepIndex>1</StepIndex>
                <StepTitle>{t('info.joinStep1Title')}</StepTitle>
                <StepText>{t('info.joinStep1Text')}</StepText>
              </StepCard>

              <ArrowHolder>
                <ArrowForwardIosIcon />
              </ArrowHolder>

              <StepCard>
                <StepIndex>2</StepIndex>
                <StepTitle>{t('info.joinStep2Title')}</StepTitle>
                <StepText>{t('info.joinStep2Text')}</StepText>
              </StepCard>

              <ArrowHolder>
                <ArrowForwardIosIcon />
              </ArrowHolder>

              <StepCard>
                <StepIndex>3</StepIndex>
                <StepTitle>{t('info.joinStep3Title')}</StepTitle>
                <StepText>{t('info.joinStep3Text')}</StepText>
              </StepCard>

              <ArrowHolder>
                <ArrowForwardIosIcon />
              </ArrowHolder>

              <StepCard>
                <StepIndex>4</StepIndex>
                <StepTitle>{t('info.joinStep4Title')}</StepTitle>
                <StepText>{t('info.joinStep4Text')}</StepText>
              </StepCard>
            </StepsFlow>

            <div className="section__title-wrapper mt-80 mb-80">
              <span className="section__back-title">
                {t('info.profitBack')}
              </span>
              <span className="section__subtitle">
                {t('info.profitSubtitle')}
              </span>
              <h2 className="section__title">
                {t('info.profitTitleBefore')}{' '}
                <span className="text__highlight">
                  {t('info.profitTitleHighlight')}
                </span>
              </h2>
            </div>

            <div>
              <ProfitHolder className="row">
                <ProfitHeader className="col-12">
                  <div>{t('info.profitIntro')}</div>
                </ProfitHeader>

                <Income className="col-xxl-6 col-xl-6 col-lg-6">
                  <div>
                    <b>{t('info.profitRevenuesLabel')}</b> <br />
                    {t('info.profitRevenue1')}
                    <br />
                    {t('info.profitRevenue2')}
                    <br />
                    {t('info.profitRevenue3')}
                  </div>
                </Income>

                <Expenses className="col-xxl-6 col-xl-6 col-lg-6">
                  <div>
                    <b>{t('info.profitExpensesLabel')}</b> <br />
                    {t('info.profitExpense1')} <br />
                    {t('info.profitExpense2')} <br />
                    {t('info.profitExpense3')}
                  </div>
                </Expenses>

                <Profit className="col-12">
                  <div>
                    <b>{t('info.profitNetLabel')}</b>{' '}
                    {t('info.profitNetAmount')}
                  </div>
                </Profit>
              </ProfitHolder>
            </div>
          </div>
        </section>

        <section className="counter__area include__bg pt-150 pb-120 counter__overlay fix">
          <div className="counter__shape">
            <img
              src={CounterShape}
              style={{width: 'auto', height: 'auto'}}
              alt=""
              aria-hidden="true"
            />
          </div>
          <div className="container">
            <div className="row" style={{alignItems: 'center'}}>
              <HelpText>{t('home.orgCtaTitle')}</HelpText>

              <HelpButtonHolder>
                <HelpButton
                  className="input__btn"
                  to={routes.organization.login}
                >
                  <CorporateFareIcon /> <span>{t('home.orgCtaRegister')}</span>
                </HelpButton>
              </HelpButtonHolder>
            </div>
          </div>
        </section>

        <WhyOnlineEvent />
      </>
    </Page>
  )
}

const ProfitHolder = styled.div``

const ProfitHeader = styled.div`
  & > div {
    font-weight: bold;
    background: var(--clr-gradient-14);
    padding: 15px;
    border-radius: 5px;
    color: #ffffff;
  }
`

const Profit = styled.div`
  & > div {
    background: #f5f5f5;
    padding: 15px;
    border-radius: 5px;
  }
  margin-top: 15px;
`

const Income = styled.div`
  & > div {
    background: #f5f5f5;
    padding: 15px;
    min-height: 110px;
    border-radius: 5px;
  }
  margin-top: 15px;
`

const Expenses = styled.div`
  & > div {
    background: #f5f5f5;
    padding: 15px;
    min-height: 110px;
    border-radius: 5px;
  }
  margin-top: 15px;
`

const InfoItem = styled.div`
  padding-top: 10px;
  padding-bottom: 10px;
  transition: all 0.2s ease;
  & > div {
    border-radius: 5px;
    background: #f5f5f5;
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.05);
  }
  &:hover > div {
    transform: translateY(-4px);
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  }
`

const InfoItemHeader = styled.h4`
  font-weight: bold;
  background: var(--clr-gradient-14);
  padding: 15px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  color: white;
  font-size: 1rem;
`

const InfoItemContent = styled.div`
  padding: 15px;
  display: flex;
  align-items: center;
  min-height: 165px;
`

const InfoItemIcon = styled.div`
  padding: 0px 15px;
  & > svg {
    font-size: 3.5rem;
    color: var(--clr-common-black);
  }
`

const StyledBlockquote = styled.blockquote`
  position: relative;
  background-size: cover;
  background-position: left center;
  border-radius: 5px;
  overflow: hidden;
  padding: 30px 20px;

  &:before {
    content: '';
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.35);
  }

  & > h3 {
    position: relative;
    z-index: 1;
    text-align: center;
    color: #ffffff;
    white-space: pre-line;
  }
`

const ProblemContainer = styled.div`
  background: #f5f5f5;
  border-radius: 5px;
  padding: 20px;
`

const ProblemGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 15px;

  @media (min-width: 992px) {
    grid-template-columns: 1fr 1fr;
  }
`

const ProblemColumn = styled.div`
  background: #fff;
  border-radius: 5px;
  padding: 15px;
`

const ProblemHeader = styled.h4`
  margin: 0 0 10px 0;
  font-weight: bold;
  font-size: 1rem;
  background: var(--clr-gradient-14);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`

const ProblemList = styled.ul`
  margin: 0;
  padding-left: 18px;
  & > li {
    margin: 6px 0;
  }
`

const SolutionList = styled.ul`
  margin: 0;
  padding-left: 18px;
  & > li {
    margin: 6px 0;
  }
`

const StepsFlow = styled.div`
  display: flex;
  align-items: stretch;
  justify-content: center;
  flex-wrap: wrap;
  gap: 10px;
`

const StepCard = styled.div`
  flex: 1 1 220px;
  min-width: 220px;
  background: #f5f5f5;
  border-radius: 5px;
  padding: 15px;
  display: flex;
  flex-direction: column;
`

const StepIndex = styled.div`
  width: 34px;
  height: 34px;
  line-height: 34px;
  text-align: center;
  border-radius: 50%;
  background: var(--clr-gradient-14);
  color: #fff;
  font-weight: bold;
  margin-bottom: 10px;
`

const StepTitle = styled.h5`
  margin: 0 0 6px 0;
  font-size: 1rem;
  font-weight: bold;
`

const StepText = styled.p`
  margin: 0;
`

const ArrowHolder = styled.div`
  align-self: center;
  display: flex;
  align-items: center;
  color: var(--clr-common-black);
  opacity: 0.5;

  & > svg {
    font-size: 2rem;
  }
`
